import * as React from "react";
import {Grid2, Paper, Typography} from "@mui/material";
import {color_blue} from "@/agentur/AgenturColors";
import {compactValue} from "@/lib/screen-class";
import {LANDING_BODY_LARGE} from "@/pages/landing-page/utils/landing-font-sizes";

export interface TestimonyCardProps {
    image: string;
    text: string;
    name: string;
    active?: boolean;
    width?: number | string;
    height?: number | string;
    noBorder?: boolean;
}

export const TestimonyCard = ({ image, text, name, active, width, height, noBorder }: TestimonyCardProps) => (
    <Paper
        elevation={!noBorder && active ? 5 : 0}
        sx={{
            flex: "0 0 auto",
            width,
            height,
            zIndex: active ? 2 : 1,
            opacity: active ? 1 : 0.5,
            transform: active ? "scale(1)" : "scale(0.85)",
            transition: "all 0.4s ease",
            backgroundColor: color_blue[3],
            marginX: 0
        }}
    >
        <Grid2
            container
            direction="row"
            gap={3}
            sx={{ padding: compactValue(2, 4) }}
            justifyContent="space-around"
            alignItems="center"
            height={height}
        >
            {/* Below `md` the image takes the card width up to its own 300 px; the SVG scales through its `viewBox`. */}
            <Grid2 size={{ xs: 5 }} sx={{ width: compactValue("100%", "300px"), maxWidth: "300px" }}>
                <svg width="300" height="340" viewBox="0 0 300 340" style={{ width: "100%", height: "auto" }}>
                    <defs>
                        <clipPath id="polygon-clip" clipPathUnits="objectBoundingBox">
                            <polygon points="0.5,0 1,0.25 1,0.75 0.5,1 0,0.75 0,0.25" />
                        </clipPath>
                    </defs>
                    <image
                        href={image}
                        width="100%"
                        height="100%"
                        preserveAspectRatio="xMidYMid slice"
                        clipPath="url(#polygon-clip)"
                    />
                </svg>
            </Grid2>
            <Grid2 size={{ xs: 12, md: 12, lg: 5 }} paddingTop={6}>
                <Typography component="div" marginBottom={2} sx={{ fontSize: LANDING_BODY_LARGE }}>
                    {text.split("\n").map((t, i, lines) => (
                        <div key={t}>
                            {i === 0 ? "“" : ""}
                            {t}
                            {i === lines.length - 1 ? "”" : ""}
                        </div>
                    ))}
                </Typography>

                <Typography fontWeight="700" marginBottom={5} sx={{ fontSize: LANDING_BODY_LARGE }}>
                    {name}
                </Typography>
            </Grid2>
        </Grid2>
    </Paper>
);
